
import { Component, Input } from '@angular/core';

import { InfluencerPost, BestPerformingExposure } from '../../../../../../models/influencer';
import { Router } from '@angular/router';
import { platformIconPathById } from '../../../../../app.constants';
import { DateUtils } from '../../../../../utils/date.utils';
import { UserService } from '../../../../../services/user.service';
import { PdfExportService } from '../../../../../services/export-pdf/pdf-export.service';
import { BestPerformingPostsComponent } from '../best-performing-posts.component';

@Component({
    selector: 'best-performing-post-item',
    templateUrl: './best-performing-post-item.component.html',
    styleUrls: ['./best-performing-post-item.component.scss']
})
export class BestPerformingPostItemComponent {
    @Input() post: BestPerformingExposure = new BestPerformingExposure();
    @Input() index: number;
    @Input() isLastItem: boolean;
    @Input() printMode: boolean;

    constructor(private pdfService: PdfExportService,
                private userService: UserService, private router: Router) { }

    getPlatformIcon(platformId: number): string {
      if (!platformId) {
        return '';
      }
      return platformIconPathById[platformId].path;
    }

    onLoadedImage() {
      this.pdfService.updateNumberImageLoaded(BestPerformingPostsComponent.COMPONENT_NAME);
    }

    onLoadedImageError() {
      this.pdfService.updateNumberImageLoaded(BestPerformingPostsComponent.COMPONENT_NAME);
    }

    get activeAccount() {
      return this.userService.getCompanyId();
    }

    formatPublishDate(publishDate: string): string {
      return DateUtils.formatDate(publishDate);
    }

    openPostPage() {
      const currentInfluencer = this.userService.getInfluencerInfo();
      // influencer platform version
      if (currentInfluencer) {
        return this.router.navigate(['dashboard', 'post', this.post.urlHash]);
      } else {
        return this.router.navigate(['post'], {queryParams: {
          influencerId: this.post.influencer_id,
          urlHash: this.post.urlHash,
          fullUrl: this.post.url,
          relativePath: this.post.relativepath,
          activeAccount: this.activeAccount
        }});
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-post-item/best-performing-post-item.component.ts